import $ from 'jquery';
import Unlink from './Unlink';
import BackgroundImage from './BackgroundImage';

export default class Hero {
  constructor(element) {
    this.element = element;
    this.$element = $(this.element);
    this.enhance();
    this.ready();
  }

  enhance() {
    this.$element.find('.node-upper-image').each((i, element) => {
      element.BackgroundImage = new BackgroundImage(element);
    });

    this.$element.find('.node-header a').each((i, element) => {
      element.Unlink = new Unlink(element);
    });
  }

  ready() {
    return this.$element.addClass('ready');
  }
}
